import { getStoreState, replaceState } from 'Utils/Store';
import { logger } from 'Utils/Logger';
import { GIFTING_PURCHASE_MODE } from 'Utils/Constants';

export const purchaseModeInitialState = {};

export const updatePurchaseMode = (payload) => {
  replaceState('purchaseMode', () => payload);
};

export const setPurchaseMode = (purchaseModeName) => {
  const {
    appConfig: {
      defaultConfig: { purchaseModeList },
    },
  } = getStoreState();

  const activePurchaseMode = purchaseModeList[purchaseModeName];

  if (activePurchaseMode) {
    updatePurchaseMode(activePurchaseMode);
  } else {
    console.debug(`ERROR: no purchaseMode found of type: ${purchaseModeName}`);
  }
};

export const resetPurchaseMode = () => {
  const {
    appConfig: {
      defaultConfig: { defaultPurchaseMode },
    },
  } = getStoreState();
  setPurchaseMode(defaultPurchaseMode);
};

export const fetchEventState = (isGiftingRelatedPage = false) => {
  const {
    appConfig: {
      defaultConfig: { defaultPurchaseMode, purchaseModeList },
    },
  } = getStoreState();
  const purchaseMode = isGiftingRelatedPage ? GIFTING_PURCHASE_MODE : defaultPurchaseMode;
  const availablePurchaseModes = Object.keys(purchaseModeList);
  if (availablePurchaseModes.includes(purchaseMode)) {
    setPurchaseMode(purchaseMode);
  } else {
    const error = `Incorrect purchase mode of "${purchaseMode}". Must be one of the following: ${availablePurchaseModes.join(
      ', '
    )}`;
    logger.error('fetch event state', { purchaseMode, purchaseModeList }, error);
    throw new Error(error);
  }
};
